
export default function ContactSection() {
  const contactMethods = [
    {
      icon: 'ri-whatsapp-line',
      title: 'WhatsApp',
      description: 'Respuesta rápida y personalizada. Ideal para cotizar tu idea.',
      action: 'Enviar Mensaje',
      link: 'https://wa.me/56982504829?text=Hola,%20me%20gustaría%20cotizar%20un%20tatuaje...',
      color: 'bg-green-500',
      hover: 'hover:bg-green-600',
      textColor: 'text-green-500'
    },
    {
      icon: 'ri-instagram-line',
      title: 'Instagram',
      description: 'Revisa nuestro portafolio actualizado y escríbenos por DM.',
      action: 'Ver Perfil',
      link: 'https://instagram.com/rebel_rabbit_tattoo',
      color: 'bg-pink-500',
      hover: 'hover:bg-pink-600',
      textColor: 'text-pink-500'
    },
    {
      icon: 'ri-mail-line',
      title: 'Correo',
      description: 'Para propuestas, colaboraciones o consultas detalladas.',
      action: 'Enviar Correo',
      link: 'mailto:contacto@rebelrabbit.cl',
      color: 'bg-purple-500',
      hover: 'hover:bg-purple-600',
      textColor: 'text-purple-500'
    }
  ];

  return (
    <section id="contacto" className="py-20 bg-gradient-to-b from-white to-pink-50">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Hablemos de tu <span className="text-pink-500">Idea</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            No usamos formularios automáticos. Preferimos el trato directo y personal
            para entender exactamente lo que buscas.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto mb-16">
          {contactMethods.map((method, index) => (
            <a
              key={index}
              href={method.link}
              target="_blank"
              rel="noopener noreferrer"
              className="group bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1 border border-gray-100 flex flex-col items-center text-center"
            >
              <div className={`w-16 h-16 rounded-full ${method.color} bg-opacity-10 flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300`}>
                <i className={`${method.icon} text-3xl ${method.textColor}`}></i>
              </div>

              <h3 className="text-2xl font-bold text-gray-900 mb-3">{method.title}</h3>
              <p className="text-gray-600 mb-8 flex-grow">
                {method.description}
              </p>

              <span className={`inline-flex items-center font-bold ${method.textColor} group-hover:underline`}>
                {method.action}
                <i className="ri-arrow-right-line ml-2 group-hover:translate-x-1 transition-transform"></i>
              </span>
            </a>
          ))}
        </div>

        {/* Location & Map */}
        <div className="bg-white rounded-3xl shadow-xl overflow-hidden max-w-5xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2">
            <div className="p-10 flex flex-col justify-center bg-gray-900 text-white">
              <h3 className="text-2xl font-bold mb-6">Visítanos en el Estudio</h3>
              <div className="space-y-6">
                <div className="flex items-start">
                  <i className="ri-map-pin-line text-2xl text-pink-500 mr-4 mt-1"></i>
                  <div>
                    <h4 className="font-bold text-lg">Dirección</h4>
                    <p className="text-gray-300">Las Urbinas 87, Oficina 26<br />Providencia, Santiago</p>
                    <p className="text-sm text-gray-400 mt-1">(Metro Los Leones)</p>
                  </div>
                </div>

                <div className="flex items-start">
                  <i className="ri-time-line text-2xl text-pink-500 mr-4 mt-1"></i>
                  <div>
                    <h4 className="font-bold text-lg">Horario de Atención</h4>
                    <p className="text-gray-300">Lunes a Sábado: 11:00 - 20:00 hrs</p>
                    <p className="text-gray-400 text-sm">Solo con cita previa</p>
                  </div>
                </div>
              </div>

              <div className="mt-8 pt-8 border-t border-gray-800">
                <p className="text-gray-400 text-sm mb-4">Síguenos en redes sociales</p>
                <div className="flex space-x-4">
                  <a href="https://instagram.com/rebel_rabbit_tattoo" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-gray-800 flex items-center justify-center hover:bg-pink-600 transition-colors">
                    <i className="ri-instagram-line text-xl"></i>
                  </a>
                  <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-gray-800 flex items-center justify-center hover:bg-blue-600 transition-colors">
                    <i className="ri-facebook-fill text-xl"></i>
                  </a>
                </div>
              </div>
            </div>

            <div className="relative h-64 lg:h-full min-h-[300px]">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3329.851336127113!2d-70.61208742426993!3d-33.42711839632326!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x9662cf662307569d%3A0x7620302251239859!2sLas%20Urbinas%2087%2C%20Oficina%2026%2C%207510107%20Providencia%2C%20Regi%C3%B3n%20Metropolitana!5e0!3m2!1ses-419!2scl!4v1709664582312!5m2!1ses-419!2scl"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen={true}
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                className="absolute inset-0 w-full h-full"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
